// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type TrashFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from trash-filled.svg
 */
export default function TrashFilledIcon(props: TrashFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="TrashFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M16 1a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1m-1.003 4.08A1 1 0 0 0 14 4H2l-.116.007a1 1 0 0 0-.865 1.19l2 10 .03.113A1 1 0 0 0 4 16h8l.118-.007a1 1 0 0 0 .863-.797l2-10z"
        />
      </g>
    </svg>
  );
}
